export function logger (msg) {
  if (!process.env.IS_PROD) {
    // eslint-disable-next-line
    console.log(msg)
  }
}
